import { render, staticRenderFns } from "./Fota.vue?vue&type=template&id=5558c27e"
import script from "./Fota.vue?vue&type=script&lang=js"
export * from "./Fota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports